import firaSansRegular from '../assets/fonts/FiraSans-Regular.ttf'

import ioniconsTtf from 'react-native-vector-icons/Fonts/Ionicons.ttf'
import materialIconsTtf from 'react-native-vector-icons/Fonts/MaterialIcons.ttf'

import fa6RegularTtf from 'react-native-vector-icons/Fonts/FontAwesome6_Regular.ttf'
import fa6SolidTtf from 'react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf'
import fa6BrandsTtf from 'react-native-vector-icons/Fonts/FontAwesome6_Brands.ttf'

const injectFontFace = (fontFamily: string, src: string) => {
  if (typeof document === 'undefined') return

  const styleId = `fontface:${fontFamily}`
  if (document.getElementById(styleId)) return

  const styleTag = document.createElement('style')
  styleTag.id = styleId
  styleTag.type = 'text/css'
  styleTag.appendChild(
    document.createTextNode(`
@font-face {
  font-family: '${fontFamily}';
  src: url(${JSON.stringify(src)}) format('truetype');
  font-display: swap;
}
`)
  )
  document.head.appendChild(styleTag)
}

// App fonts
injectFontFace('FiraSans-Regular', firaSansRegular)

// Vector icon fonts used throughout the app
injectFontFace('Ionicons', ioniconsTtf)
injectFontFace('Material Icons', materialIconsTtf)
injectFontFace('FontAwesome6Free-Regular', fa6RegularTtf)
injectFontFace('FontAwesome6Free-Solid', fa6SolidTtf)
injectFontFace('FontAwesome6Brands-Regular', fa6BrandsTtf)

